<template>
<div class="station-platform-selection">
   <div class='station-selection label-item'>
            <label>Kohdeasemat / laiturit</label>
            <div>
            <b-badge href="#" @click='selectAll()'><b-icon icon="list-check"></b-icon>Kaikki</b-badge>
            <SelectList :options="stationOptions('Alku')" @select="selectStartStation" :searchable="true" :clearable="true" :value="0" :disabled="disabled" />
            <SelectList :options="stationOptions('Loppu')" @select="selectEndStation" :searchable="true" :clearable="true" :value="0" :disabled="disabled"/>
            </div>
            <!--t-button type="icon" icon="list-check" title="Kaikki asemat" @click="selectAll()"></t-button-->  
    </div>
      
    <div v-if="selectedStations.length > 0" class='selected-stations'>
            <div v-if="selectedStations.length > 1" class="station-list-header">
                <p-checkbox v-model="platform1Selected">Laituri 1</p-checkbox>
                <p-checkbox v-model="platform2Selected">Laituri 2</p-checkbox>
                <p-checkbox v-model="platform3Selected">Laituri 3</p-checkbox>
            </div>

            <div class="station-list">
                <div v-for="s in selectedStations" :key="s.id" class='platform-selection'> 
                    <b-badge href="#" @click='unselect(s.id)'>{{ s.name }}<span class='x'>x</span></b-badge>
                    
                    <p-checkbox v-model="platform1Selected">Laituri 1</p-checkbox>
                    <p-checkbox v-model="platform2Selected">Laituri 2</p-checkbox>
                    <p-checkbox v-if="s.platforms == 3" v-model="platform3Selected">Laituri 3</p-checkbox>
                </div>
            </div>
    </div>

</div>

</template>

<script>

export default ({
    props: ['stations'],
    data: function() {
        return {
            disabled: false,       
            selectedStations: [],
            startStation: null,
            endStation: null,
            platform1Selected: true,
            platform2Selected: true,
            platform3Selected: true,
        }
    },
    methods: {
        stationOptions(label){
            var optionList = [];

            optionList.push(  { id: 0, label: label, icon: 'filter', caption: label } ); 
            for (var item of this.stations) {
                optionList.push({ id: item.id, label: item.name });
            }
            return optionList;
        },
        selectStartStation(id){
            if(id){
                this.startStation = this.stations.find(station => station.id == id);
                if(this.endStation){
                    let startIndex = this.stations.indexOf(this.startStation);
                    let endIndex   = this.stations.indexOf(this.endStation);
                    if(startIndex > endIndex){
                        let tmp = startIndex;
                        startIndex = endIndex;
                        endIndex = tmp;
                    }
                    this.selectedStations = this.stations.slice(startIndex, endIndex + 1) 
                }
                else 
                    this.selectedStations.push(this.startStation);
            } else {
                this.startStation = null;
                this.selectedStations = [];
                if(this.endStation)
                    this.selectedStations.push(this.endStation);
            }
        },
        selectEndStation(id){
            if(id){
                this.endStation = this.stations.find(station => station.id == id);

                if(this.startStation){
                    let startIndex = this.stations.indexOf(this.startStation);
                    let endIndex   = this.stations.indexOf(this.endStation);
                    if(startIndex > endIndex){
                        let tmp = startIndex;
                        startIndex = endIndex;
                        endIndex = tmp;
                    }
                    this.selectedStations = this.stations.slice(startIndex, endIndex + 1) 
                }   
                else 
                    this.selectedStations.push(this.endStation);
            }
            else {
                this.endStation = null;
                this.selectedStations = [];
                if(this.startStation)
                    this.selectedStations.push(this.startStation);
            }
        },
        selectAll(){
             this.selectedStations.push(...this.stations);
        },
        unselect(id){
            this.selectedStations = this.selectedStations.filter(station => station.id != id);
        },
    }
})
</script>